import { useEffect } from 'react';
import { useOidc } from '@nohara-dxdev/react-oidc';
import { useNavigate } from 'react-router';

import { PropertiesRegistrationForm } from '../components/properties/properties-registration-form';

import { checkPermission } from '@/utils/helpers';
import { FunctionName, PermissionAction } from '@/lib/enums';

export const PropertiesRegisterPage = () => {
  const { permissions } = useOidc();
  const navigate = useNavigate();

  useEffect(() => {
    if (!checkPermission(permissions, FunctionName.PROPERTY_MANAGEMENT, PermissionAction.CREATE)) {
      navigate('/404');
      return;
    }
  }, [permissions, navigate]);
  return <PropertiesRegistrationForm />;
};
